<img [src]="image" [width]="size" [height]="size" 
[style.border-radius]="roundness+'%'"
class="avatar">

